import * as React from 'react';

import { Provider } from 'react-redux';
import { Router as BrowserRouter, Route, Switch } from 'react-router-dom';

import store from 'pages/store';
import AccountingRoutes from 'pages/views/accounting/routes';
import DevicesRoutes from 'pages/views/devices/routes';
import EcomRoutes from 'pages/views/ecom/routes';
import FirstStartRoutes from 'pages/views/first-start/routes';
import Loading from 'pages/views/generic/Loading';
import NotFound from 'pages/views/generic/NotFound';
import GiftcardsRoutes from 'pages/views/gift-cards/routes';
import HomeRoutes from 'pages/views/home/routes';
import InventoryRoutes from 'pages/views/inventory/routes';
import MarketplaceRoutes from 'pages/views/inventory/SuppliersIframe/routes';
import MarketingRoutes from 'pages/views/marketing/routes';
import LightspeedCapitalRoutes from 'pages/views/payments/lightspeed-capital/routes';
import ReportRoutes from 'pages/views/reports/routes';
import SettingsRoutes from 'pages/views/settings/routes';
import SubscriptionsRoutes from 'pages/views/subscriptions/routes';

// This is our "legacy" adapter to load React Pages in Retail's routing system.
// We are not importing the class as it's used globally only. In this case
// we only want to import the file and have the code outside the class execute.
import './retail';
import history from './history';

interface Props {
  loading: boolean;
}

const Router: React.FunctionComponent<Props> = ({ loading }) => (
  <Provider store={store}>
    <BrowserRouter history={history}>
      {loading ? (
        <Route component={Loading} />
      ) : (
        <Switch>
          {[
            ...HomeRoutes,
            ...InventoryRoutes,
            ...SubscriptionsRoutes,
            ...EcomRoutes,
            ...FirstStartRoutes,
            ...ReportRoutes,
            ...SettingsRoutes,
            ...MarketingRoutes,
            ...DevicesRoutes,
            ...LightspeedCapitalRoutes,
            ...GiftcardsRoutes,
            ...MarketplaceRoutes,
            ...AccountingRoutes,
          ]}
          <Route component={NotFound} />
        </Switch>
      )}
    </BrowserRouter>
  </Provider>
);

export default Router;
